var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10904 3.13325L5.55709 1.7891C5.64783 1.51687 5.90259 1.33325 6.18954 1.33325H9.78954C10.0765 1.33325 10.3313 1.51687 10.422 1.7891L10.87 3.13325H13.9895C14.3577 3.13325 14.6562 3.43173 14.6562 3.79992C14.6562 4.16811 14.3577 4.46659 13.9895 4.46659H13.4181L12.9289 12.784C12.8667 13.8412 11.9913 14.6666 10.9323 14.6666H5.04675C3.9878 14.6666 3.11238 13.8412 3.0502 12.784L2.56094 4.46659H2.00016C1.63197 4.46659 1.3335 4.16811 1.3335 3.79992C1.3335 3.43173 1.63197 3.13325 2.00016 3.13325H5.10904ZM6.51449 3.13325H9.46459L9.30904 2.66659H6.67005L6.51449 3.13325ZM12.0825 4.46659H3.89658L4.38123 12.7057C4.40196 13.0581 4.69377 13.3333 5.04675 13.3333H10.9323C11.2853 13.3333 11.5771 13.0581 11.5979 12.7057L12.0825 4.46659ZM9.12417 6.15833C9.14714 5.79086 9.46366 5.51158 9.83113 5.53455C10.1986 5.55752 10.4779 5.87403 10.4549 6.2415L10.1549 11.0415C10.1319 11.409 9.81543 11.6883 9.44796 11.6653C9.08048 11.6423 8.80121 11.3258 8.82417 10.9583L9.12417 6.15833ZM7.15491 10.9583C7.17788 11.3258 6.8986 11.6423 6.53113 11.6653C6.16366 11.6883 5.84714 11.409 5.82417 11.0415L5.52417 6.2415C5.50121 5.87403 5.78048 5.55752 6.14796 5.53455C6.51543 5.51158 6.83194 5.79086 6.85491 6.15833L7.15491 10.9583Z",
    fill: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconBlue);
export default __webpack_public_path__ + "static/media/delete-icon-blue.7562dbbed98848aef6bb708ca59ff8fa.svg";
export { ForwardRef as ReactComponent };